import { render, staticRenderFns } from "./DetailsTankComponent.vue?vue&type=template&id=356b4f58&"
import script from "./DetailsTankComponent.vue?vue&type=script&lang=js&"
export * from "./DetailsTankComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTankComponent.vue?vue&type=style&index=0&id=356b4f58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports